import React, { HTMLAttributes, useState } from "react";

import Button from "@material-ui/core/Button";

import { NONE } from "common/constants";
import ErrorBoundary from "components/ErrorBoundary";
import TableCellWrapper from "components/VetExamsTable/TableCellWrapper";
import RisksHistoryPopup from "./RisksHistoryPopup";

import useStyles from "./styles";

interface IProps extends HTMLAttributes<HTMLDivElement> {
  entityId?: string;
  riskFactorShortDescriptions: string[];
  horseName: string;
  horseId: string;
}

const RiskFactorsCell = (props: IProps) => {
  const { horseId, horseName, riskFactorShortDescriptions, ...restProps } =
    props;

  const classes = useStyles();

  const [isRisksFactorsPopupOpened, setIsRisksFactorsPopupOpened] =
    useState(false);

  const handleOpenRisksFactorsPopup = () => {
    setIsRisksFactorsPopupOpened(true);
  };

  const handleCloseRisksFactorsPopup = () => {
    setIsRisksFactorsPopupOpened(false);
  };

  const riskFactorsNumber = riskFactorShortDescriptions.length;

  const riskFactorDescriptions = riskFactorsNumber ? (
    riskFactorShortDescriptions.map((item, index) => (
      <div key={`risk-factors-${index}`} className={classes.riskFactorsItem}>
        {item}
      </div>
    ))
  ) : (
    <span className={classes.noRiskFactors}>{NONE}</span>
  );

  return (
    <TableCellWrapper
      {...restProps}
      className={classes.riskFactors}
      fadedOut={!riskFactorsNumber}
    >
      {Boolean(riskFactorsNumber) && (
        <Button
          className={classes.risksFactorsNumber}
          onClick={handleOpenRisksFactorsPopup}
        >
          {riskFactorsNumber}
        </Button>
      )}

      {riskFactorDescriptions}

      {isRisksFactorsPopupOpened && (
        <ErrorBoundary>
          <RisksHistoryPopup
            horseId={horseId}
            horseName={horseName}
            onClose={handleCloseRisksFactorsPopup}
          />
        </ErrorBoundary>
      )}
    </TableCellWrapper>
  );
};

export default React.memo(RiskFactorsCell);
